<template>
    <modal
        height="auto"
        @closed="hideModal"
        :scrollable="true"
        :resizable="true"
        :adaptive="true"
        name="dataDownloadModal"
        transition="pop-out"
    >
        <div class="px-4 py-6 bg-white border-0 modal-content rounded-0">
            <div class="modal-header">
                <div class="float-right" role="button" @click="hideModal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-6 h-6"
                        viewBox="0 0 33 33"
                    >
                        <g
                            fill="none"
                            fill-rule="evenodd"
                            stroke="#212121"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            transform="translate(3 3)"
                        >
                            <line x1="20" y2="20" />
                            <line x2="20" y2="20" />
                        </g>
                    </svg>
                </div>
            </div>
            <div class="mx-6 mt-8 modal-body">
                <h2 class="text-6xl font-light text-center">
                    {{ trans.get('data.download_reports.components.title') }}
                </h2>
                <p class="mt-3 font-light">
                    {{ trans.get('data.download_reports.components.text1') }} <span class="text-green-400">{{ user_email }}</span> {{ trans.get('data.download_reports.components.text2') }}
                </p>
            </div>
            <div class="my-12 text-center modal-footer">
                <div>
                    <a
                        role="button"
                        class="px-12 py-4 tracking-wide text-green-200 bg-green-800 rounded font-sans-secondary"
                        target="_blank"
                        @click="hideModal"
                    >
                        {{ trans.get('buttons.general.close') }}
                    </a>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    props: {
        user_email: {
            type: String,
            required: true,
        }
    },
    mounted() {
        this.showModal();
    },
    methods: {
        showModal() {
            this.$modal.show('dataDownloadModal');
        },
        hideModal() {
            this.$modal.hide('dataDownloadModal');
            this.$emit('close-modal');
        }
    }
};
</script>
